import { c as _c } from "react/compiler-runtime";
import ActiveLottieLink from '@pc/components/atoms/button/sidebar/ActiveLottieLink';
function ActiveLinkContainer() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="border-borderBg01 border-b px-[8px] py-[15px]"><ActiveLottieLink mappingPath="live">{"LIVE"}</ActiveLottieLink><ActiveLottieLink mappingPath="ranking">{"BJ\uB7AD\uD0B9"}</ActiveLottieLink><ActiveLottieLink mappingPath="pick">{"PICK"}</ActiveLottieLink></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default ActiveLinkContainer;